import React from 'react';

export const selectedIcon = `<svg
id="Checkbox-selected"
xmlns="http://www.w3.org/2000/svg"
width="14"
height="14"
viewBox="0 0 14 14"
>
<rect
  id="Rectangle_2336"
  data-name="Rectangle 2336"
  width="14"
  height="14"
  rx="3"
  fill="#0047ba"
/>
<path
  id="Path_18"
  data-name="Path 18"
  d="M4.4,7.3,0,2.908l1.42-1.42L4.4,4.4,8.792,0l1.42,1.42Z"
  transform="translate(1.734 3.763)"
  fill="#fff"
/>
</svg>`;

export const deselectedIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
<g id="Checkbox" fill="#fff" stroke="#aaafb9" stroke-width="1">
  <rect width="20" height="20" rx="6" stroke="none"/>
  <rect x="0.5" y="0.5" width="19" height="19" rx="5.5" fill="none"/>
</g>
</svg>`;

// yellow Color background
export const yellowColorWithSelectedIcon = `<svg id="Checkbox-selected" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
<rect id="Rectangle_2336" data-name="Rectangle 2336" width="20" height="20" rx="6" fill="#f1f511"/>
<path id="Path_18" data-name="Path 18" d="M4.4,7.3,0,2.908l1.42-1.42L4.4,4.4,8.792,0l1.42,1.42Z" transform="translate(4.734 6.763)" fill="#fff"/>
</svg>`;

export const yellowColorWithDeselectedIcon = `<svg id="Component_217_1" data-name="Component 217 – 1" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
<rect id="Rectangle_2708" data-name="Rectangle 2708" width="20" height="20" rx="6" fill="#f1f511"/>
</svg>`;
// blue Color background
export const blueColorWithSelectedIcon = `<svg id="Checkbox-selected" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
<rect id="Rectangle_2336" data-name="Rectangle 2336" width="20" height="20" rx="6" fill="#347dc6"/>
<path id="Path_18" data-name="Path 18" d="M4.4,7.3,0,2.908l1.42-1.42L4.4,4.4,8.792,0l1.42,1.42Z" transform="translate(4.734 6.763)" fill="#fff"/>
</svg>`;

export const blueColorWithDeselectedIcon = `<svg id="Component_218_1" data-name="Component 218 – 1" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
<rect id="Rectangle_2709" data-name="Rectangle 2709" width="20" height="20" rx="6" fill="#347dc6"/>
</svg>`;

// pink Color background
export const pinkColorWithSelectedIcon = `<svg id="Checkbox-selected" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
<rect id="Rectangle_2336" data-name="Rectangle 2336" width="20" height="20" rx="6" fill="#f7b3bc"/>
<path id="Path_18" data-name="Path 18" d="M4.4,7.3,0,2.908l1.42-1.42L4.4,4.4,8.792,0l1.42,1.42Z" transform="translate(4.734 6.763)" fill="#fff"/>
</svg>`;

export const pinkColorWithDeselectedIcon = `<svg id="Component_219_1" data-name="Component 219 – 1" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
<rect id="Rectangle_2710" data-name="Rectangle 2710" width="20" height="20" rx="6" fill="#f7b3bc"/>
</svg>`;
// grey Color background
export const greyColorWithSelectedIcon = `<svg id="Checkbox-selected" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
<rect id="Rectangle_2336" data-name="Rectangle 2336" width="20" height="20" rx="6" fill="#545955"/>
<path id="Path_18" data-name="Path 18" d="M4.4,7.3,0,2.908l1.42-1.42L4.4,4.4,8.792,0l1.42,1.42Z" transform="translate(4.734 6.763)" fill="#fff"/>
</svg>`;

export const greyColorWithDeselectedIcon = `<svg id="Component_220_1" data-name="Component 220 – 1" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
<path id="Path_492" data-name="Path 492" d="M6,0h8a6,6,0,0,1,6,6v8a6,6,0,0,1-6,6H6a6,6,0,0,1-6-6V6A6,6,0,0,1,6,0Z" fill="#545955"/>
</svg>`;
// green Color background
export const greenColorWithSelectedIcon = `<svg id="Checkbox-selected" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
<rect id="Rectangle_2336" data-name="Rectangle 2336" width="20" height="20" rx="6" fill="rgb(160, 192, 160)"/>
<path id="Path_18" data-name="Path 18" d="M4.4,7.3,0,2.908l1.42-1.42L4.4,4.4,8.792,0l1.42,1.42Z" transform="translate(4.734 6.763)" fill="#fff"/>
</svg>`;

export const greenColorWithDeselectedIcon = `<svg id="Component_220_1" data-name="Component 220 – 1" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
<path id="Path_492" data-name="Path 492" d="M6,0h8a6,6,0,0,1,6,6v8a6,6,0,0,1-6,6H6a6,6,0,0,1-6-6V6A6,6,0,0,1,6,0Z" fill="rgb(160, 192, 160)"/>
</svg>`;
